import { useDispatch, useSelector } from 'react-redux';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

import {
  getEventsCourseCalendar,
  getDayEventsCourseCalendar,
  getSelectedEvent,
  getSelectedSession,
  getSessionAsync,
  selectSession,
} from 'store/calendar/index';
import { handleToastError } from 'helpers/index';
import useI18n from '../use-i18n';

// events
export const useEvents = () => {
  const events = useSelector(getEventsCourseCalendar);
  return events;
};
// events
export const useDayEvents = () => {
  const dayEvents = useSelector(getDayEventsCourseCalendar);
  return dayEvents;
};

export const useSelectedEvent = () => {
  const event = useSelector(getSelectedEvent);
  return event;
};

// section
export const useSelectedSession = () => {
  const section = useSelector(getSelectedSession);
  return section;
};

export const useFetchSession = () => {
  const i18n = useI18n();
  const dispatch = useDispatch();
  const { query } = useRouter();

  useEffect(() => {
    const callApi = async () => {
      try {
        dispatch(selectSession(undefined));
        await dispatch(getSessionAsync(query?.session));
      } catch (e) {
        handleToastError(e, i18n);
      }
    };

    if (query?.session) {
      callApi();
    }

    return () => dispatch(selectSession(undefined));
  }, [query?.session]);
};
